import React from 'react';
import FileTypeIcon from "./FileTypeIcon";
import SubscribeButton from '../subscription/SubscribeButton';
import moment from "moment";
import {INTERNAL_DOCUMENT_VIEW_PATH, PUBLIC_DOCUMENT_DOWNLOAD_PATH} from './../ajax/sdgOnlinePaths';
import {Saga} from "./actions";
import connect from "react-redux/es/connect/connect";
import * as userSelectors from "../user/selectors";

const Result = ({latestMimeType, documentId, documentName, filename, highlightText, categoryId, category, lastUpdated, updateSearchTerm, userLoggedIn }) => {

  const createMarkup = () => ({__html: highlightText});
  const getDocumentUrl = (documentId) => ((userLoggedIn ? INTERNAL_DOCUMENT_VIEW_PATH : PUBLIC_DOCUMENT_DOWNLOAD_PATH) + documentId);

  return (
    <div className='list-group-item'>

      <h5>
        <FileTypeIcon mimeType={latestMimeType}/>
        <a href={getDocumentUrl(documentId)}>{documentName} - ({filename}) </a>
      </h5>

      <div className='highlights' dangerouslySetInnerHTML={createMarkup()}/>

      <div className="text-muted">

        <button
          type="button"
          className="btn btn-link"
          onClick={evt => {
            updateSearchTerm(category);
            evt.preventDefault();
          }}>
          {category}
        </button>

        <SubscribeButton categoryId={categoryId}/> {lastUpdated && <span>- Last Updated {moment(lastUpdated).format('DD/MM/YYYY')}</span>}
      </div>

    </div>
  );

}

const mapStateToProps = (state) => ({
  userLoggedIn: userSelectors.isLoggedIn(state)
});

const mapDispatchToProps = dispatch => ({
  updateSearchTerm: (searchTerm) => dispatch(Saga.setSearchTerm(searchTerm, 0))
});

export default connect(mapStateToProps, mapDispatchToProps)(Result);